import { Route, Routes, useLocation, useNavigate } from "react-router"
import CreateCourse from "../components/admin/CreateCourse"
import EditCourse from "../components/admin/EditCourse"
import Users from "../components/admin/Users"
import Card from "../components/Card"
import { useBackspaceNavigation } from "../hooks/useBackspaceNavigation"
import { useAppState } from "../overmind"


// AdminPage is the page containing the admin-only components.
const AdminPage = () => {
    const state = useAppState()
    const navigate = useNavigate()
    const location = useLocation()

    // Objects containing props for the cards in the admin page.
    // TODO: Perhaps make a Card prop type.
    const manageUsers = { title: "Manage Users", text: "View and manage all users.", buttonText: "Manage Users", to: "/admin/manage" }
    const createCourse = { title: "Create Course", text: "Create a new course.", buttonText: "Create Course", to: "/admin/create" }
    const editCourse = { title: "Edit Course", text: "Edit an existing course.", buttonText: "Edit Course", to: "/admin/edit" }

    // If the user is not an admin, redirect to the home page.
    if (!state.self.IsAdmin) {
        navigate("/")
    }

    const root = "/admin"
    // Enable Backspace keyboard shortcut to navigate back to root
    useBackspaceNavigation(root)

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" hidden={location.pathname !== root}>
                <Card {...manageUsers} />
                <Card {...createCourse} />
                <Card {...editCourse} />
            </div>

            <Routes>
                <Route path="/manage" element={<Users />} />
                <Route path="/create" element={<CreateCourse />} />
                <Route path="/edit" element={<EditCourse />} />
            </Routes>
        </>
    )
}

export default AdminPage
